export const ActiveFilterToPeriod = {
  0: "weekly",
  1: "monthly",
  2: "yearly",
  3: "today",
};

export const ActiveFilterToSleepMetricsPeriod = {
  0: "yesterday",
  1: "last_30_days",
  2: "last_6_months",
};

export const ProductVariants = {
  // each variant has its own stock
  INDIVIDUAL: "individual",
  // only main product has its own stock
  QUANTITY: "quantity",
  // Does not have its own stock . Instead is combination with other products
  COMPOSITION: "composition",
};

export const ProductIds = {
  BASE_COMPLETE_SOLUTION: "9c3a9530-b4bb-4b4a-a339-daecb8fbbd6e",
  COMPLETE_SOLUTION_CUSTOM: "0197bfa0-cd09-7777-ad95-8d7153a84b4c",
  BASE_GRIND_GUARD: "9c3a97c3-42ed-4c5d-a6e7-4064b83cf9a6",
  IMPRESSION_KIT: "9d883f37-6fdb-4854-ac25-70503d43d694",
};

export const Roles = {
  PATIENT: "patient",
  DENTIST: "dentist",
  GUEST: "guest",
};

export const CustomExceptions = {
  USER_EXISTS: "UserAlreadyExistsException",
  DENTISTS_EXISTS: "DentistAlreadyExistsException",
  DENTIST_NOT_FOUND: "DentistNotFoundException",
  DENTIST_PENDING_APPROVAL: "DentistPendingApprovalException",
};

export const DeviceTypes = {
  IOS: "ios-app",
  ANDROID: "android-app",
  WEBSITE: "website",
};

export const TransactionReimbursementStatus = {
  PENDING: 0,
  REIMBURSED: 1,
  CANCELLED: 2,
};

export const UserStatus = {
  ACTIVE: 1,
  INACTIVE: 0,
};
